
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gallery.css';
import Footer from "../Components/Footer";
import MegaNavbar from '../Components/MegaNavbar';
import GalleryCarousel from '../Components/GalleryCarousel';


const imageData = [


  // ..............1 WSSP Meeting pictures .................
  
  {
    src: '../WSSPMeeting/DSC_0890.JPG',  
  
    department: 'WSSP Meeting',
  
  },
  {
    src: '../WSSPMeeting/DSC_0901.JPG',
    department: 'WSSP Meeting', 
    // caption: 'Caption for image 2',
  },
  {
    src: '../WSSPMeeting/DSC_0907.JPG',
    department: 'WSSP Meeting',
    // caption: 'Caption for image 3',
  },


  // .................2 3-days workshop on SPSS Pictures ............



  {
    src: '../3-days workshop on SPSS/DSC_0063.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
  {
    src: '../3-days workshop on SPSS/DSC_0064.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
  {
    src: '../3-days workshop on SPSS/DSC_0066.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
  {
    src: '../3-days workshop on SPSS/DSC_0071.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
  {
    src: '../3-days workshop on SPSS/DSC_0116.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
 
  {
    src: '../3-days workshop on SPSS/IMG_5381.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
 
  {
    src: '../3-days workshop on SPSS/IMG_5393.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },
 
  {
    src: '../3-days workshop on SPSS/IMG_5395.JPG',
    department: '3-days workshop on SPSS',
   
    // caption: 'Caption for image 3',
  },
 
  {
    src: '../3-days workshop on SPSS/IMG_5402.JPG',
    department: '3-days workshop on SPSS',
    // caption: 'Caption for image 3',
  },





//  .................3 World environment day june 5 2023 ................
  
  {
    src: '../World environment day june 5 2023/DSC_0876.JPG',
    department: 'World environment day june 5 2023',
    // caption: 'Caption for image 3',
  },
  {
    src: '../World environment day june 5 2023/DSC_0877.JPG',
    department: 'World environment day june 5 2023',
    // caption: 'Caption for image 3',
  },
  {
    src: '../World environment day june 5 2023/DSC_0885.JPG',
    department: 'World environment day june 5 2023',
    // caption: 'Caption for image 3',
  },
  
  {
    src: '../World environment day june 5 2023/DSC_0908.JPG',
    department: 'World environment day june 5 2023',
    // caption: 'Caption for image 3',
  },
  {
    src: '../World environment day june 5 2023/DSC_0952.JPG',
    department: 'World environment day june 5 2023',
    // caption: 'Caption for image 3',
  },

  // ..................4  Training on Mendeley 16 dec 2022...................

  {
    src: '../Training on Mendeley 16 dec 2022/IMG_6125.JPG',
    department: 'Training on Mendeley 16 dec 2022',
    // caption: 'Caption for image 3',
  },
  {
    src: '../Training on Mendeley 16 dec 2022/IMG_6275.JPG',
    department: 'Training on Mendeley 16 dec 2022',
    // caption: 'Caption for image 3',
  },
  
  {
    src: '../Training on Mendeley 16 dec 2022/Pic 1.JPG',
    department: 'Training on Mendeley 16 dec 2022',
    // caption: 'Caption for image 3',
  },
  
  {
    src: '../Training on Mendeley 16 dec 2022/Pic 2.JPG',
    department: 'Training on Mendeley 16 dec 2022',
    // caption: 'Caption for image 3',
  },
  
  {
    src: '../Training on Mendeley 16 dec 2022/Pic 3.JPG',
    department: 'Training on Mendeley 16 dec 2022',
    // caption: 'Caption for image 3',
  },


// ..................14 june 2023 workshop...................


  {
    src: '../14 june 2023 workshop/DSC_0323.JPG',
    department: '14 june 2023 workshop',
    // caption: 'Caption for image 3',
  },
  {
    src: '../14 june 2023 workshop/DSC_0326.JPG',
    department: '14 june 2023 workshop',
    // caption: 'Caption for image 3',
  },
  {
    src: '../14 june 2023 workshop/DSC_0349.JPG',
    department: '14 june 2023 workshop',
    // caption: 'Caption for image 3',
  },
  
  {
    src: '../14 june 2023 workshop/DSC_0351.JPG',
    department: '14 june 2023 workshop',
    // caption: 'Caption for image 3',
  },
  // ...................3rd ORIC-steering committee meeting 14 may 2024.....................
  {
    src: '../3rd ORIC-steering committee meeting 14 may 2024/DSC_0003.JPG',
    department: '3rd ORIC-steering committee meeting 14 may 2024',
    // caption: 'Caption for image 3',
  },
  {
    src: '../3rd ORIC-steering committee meeting 14 may 2024/DSC_0005.JPG',
    department: '3rd ORIC-steering committee meeting 14 may 2024',
    
  },
  {
    src: '../3rd ORIC-steering committee meeting 14 may 2024/DSC_0006.JPG',
    department: '3rd ORIC-steering committee meeting 14 may 2024',
    
  },
  {
    src: '../3rd ORIC-steering committee meeting 14 may 2024/DSC_0010.JPG',
    department: '3rd ORIC-steering committee meeting 14 may 2024',
    
  },
  {
    src: '../5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main/DSC_0176.JPG',
    department: '5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main',
    
  },
  {
    src: '../5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main/DSC_0189.JPG',
    department: '5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main',
    
  },
  {
    src: '../5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main/DSC_0198.JPG',
    department: '5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main',
    
  },
  
  {
    src: '../5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main/DSC_0205.JPG',
    department: '5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main',
    
  },
  {
    src: '../5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main/DSC_0209.JPG',
    department: '5 march 2024 Nikkah, Talaq and Khula k Ahkam Quran aur sunnat ki roshni main',
    
  },
  
 

];

const Sidebar= () => {

  

  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = (index) => {
    setCurrentIndex(index);
    setShow(true);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imageData.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + imageData.length) % imageData.length);
  };

  const groupedImages = imageData.reduce((acc, image, index) => {
    if (!acc[image.department]) {
      acc[image.department] = [];
    }
    acc[image.department].push({ ...image, index });
    return acc;
  }, {});

  return (
    <>
<MegaNavbar/>
<h3 className='gallery_heading'> Gallery </h3>

    <div className="image-gallery-container container">
<GalleryCarousel/>


      {Object.keys(groupedImages).map((department) => (
        <div key={department} className="department-section">
          <h2 className="department-title">{department}</h2>
          <div className="gallery">
            {groupedImages[department].map((image) => (
              <div key={image.index} className="gallery-item">
                <img
                  src={image.src}
                  alt={image.caption}
                  onClick={() => handleShow(image.index)}
                  className="gallery-img"
                />
                <p className="image-caption">{image.caption}</p>
              </div>
            ))}
          </div>
        </div>
      ))}

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Gallery</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <img src={imageData[currentIndex].src} alt={imageData[currentIndex].caption} className="modal-image" />
          <p className="modal-caption">{imageData[currentIndex].caption}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePrevious}>
            Previous
          </Button>
          <Button variant="primary" onClick={handleNext}>
            Next
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    <Footer/>
    </>
  );
};

export default Sidebar;

































// import React, { useState } from 'react';
// import { Modal, Button } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './Sidebar.css'


// const images = [
  // { src: '../WSSPMeeting/DSC_0890.JPG', alt: 'WSSB Meeting', link: '../WSSPMeeting/DSC_0890.JPG',link: '../WSSPMeeting/DSC_0890.JPG', link: '../WSSPMeeting/DSC_0890.JPG'},
  // { src: '../WSSPMeeting/DSC_0890.JPG', alt: 'Image 2', link: '../WSSPMeeting/DSC_0890.JPG' },
//   { src: '../WSSPMeeting/DSC_0890.JPG', alt: 'Image 2', link: '../WSSPMeeting/DSC_0890.JPG' },
//   { src: '../WSSPMeeting/DSC_0890.JPG', alt: 'Image 2', link: '../WSSPMeeting/DSC_0890.JPG' },
//   // Add more images here
// ];

// const Sidebar = () => {
//   return (
//     <div className="gallery">
//       {images.map((image, index) => (
//         <a href={image.link} key={index} className="gallery-item">
//           <img src={image.src} alt={image.alt} />
//           <div className="overlay">{image.alt}</div>
//         </a>
//       ))}
//     </div>
//   );
// };



// src/ImageGallery.js


// const images = [
 
//   '../WSSPMeeting/DSC_0901.JPG',
//   '../WSSPMeeting/DSC_0890.JPG',
//   '../WSSPMeeting/DSC_0907.JPG',
   
//   '../WSSPMeeting/DSC_0901.JPG',
//   '../WSSPMeeting/DSC_0890.JPG',
//   '../WSSPMeeting/DSC_0907.JPG',
   
//   '../WSSPMeeting/DSC_0901.JPG',
//   '../WSSPMeeting/DSC_0890.JPG',
//   '../WSSPMeeting/DSC_0907.JPG',
   
//   '../WSSPMeeting/DSC_0901.JPG',
//   '../WSSPMeeting/DSC_0890.JPG',
//   '../WSSPMeeting/DSC_0907.JPG',
   
//   '../WSSPMeeting/DSC_0901.JPG',
//   '../WSSPMeeting/DSC_0890.JPG',
//   '../WSSPMeeting/DSC_0907.JPG',
   
//   // Add paths for all your images
//  ];

// const Sidebar = () => {
  
//   const [show, setShow] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const handleClose = () => setShow(false);
//   const handleShow = (index) => {
//     setCurrentIndex(index);
//     setShow(true);
//   };

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//   };

//   const handlePrevious = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
//   };

//   return (
//     <div>
//       <div className="gallery">
//         {images.map((image, index) => (
//           <img
//             key={index}
//             src={image}
//             alt={`Gallery image ${index + 1}`}
//             onClick={() => handleShow(index)}
//             className="gallery-img"
//           />
//         ))}
//       </div>

//       <Modal show={show} onHide={handleClose} size="lg" centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Image Gallery</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <img src={images[currentIndex]} alt={`Gallery image ${currentIndex + 1}`} className="w-100" />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handlePrevious}>
//             Previous
//           </Button>
//           <Button variant="primary" onClick={handleNext}>
//             Next
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default Sidebar;
